import script from "./CaplsuleLegend.vue?vue&type=script&setup=true&lang=js"
export * from "./CaplsuleLegend.vue?vue&type=script&setup=true&lang=js"

import "./CaplsuleLegend.vue?vue&type=style&index=0&id=e527f066&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e527f066"]])

export default __exports__